import type { ReactNode } from 'react';

/** Shared layout for legal/info content pages (prose styling without a plugin). */
export function LegalPage({
  title,
  updated,
  intro,
  children,
}: {
  title: string;
  updated?: string;
  intro?: string;
  children: ReactNode;
}) {
  return (
    <div className="container-page py-12 md:py-16">
      <div className="mx-auto max-w-prose">
        <h1 className="font-display text-display-sm font-extrabold text-ink">{title}</h1>
        {updated && <p className="mt-2 text-sm text-ink-faint">Last updated {updated}</p>}
        {intro && <p className="mt-5 text-lg text-ink-muted">{intro}</p>}
        <div className="mt-8 space-y-4 text-ink-muted [&_a]:text-brand-soft [&_a:hover]:text-brand [&_h2]:mb-2 [&_h2]:mt-9 [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-ink [&_h3]:mb-1 [&_h3]:mt-5 [&_h3]:font-semibold [&_h3]:text-ink [&_li]:leading-relaxed [&_p]:leading-relaxed [&_ul]:list-disc [&_ul]:space-y-1.5 [&_ul]:pl-5">
          {children}
        </div>
      </div>
    </div>
  );
}
